<app-loader />
<router-outlet />
<app-toast />
<app-upload-progress-toast />
